import { PaymentElement } from '@stripe/react-stripe-js';
import LockIcon from '../../icons/Lock';
import StripeIcon from '../../icons/Stripe';
import { trackPaymentFieldClick } from '../../analytics';
import useDoctorConfirmationContext from '../../useDoctorConfirmationContext';

import type { StripeElementType } from '@stripe/stripe-js';
import type { MiniInterviewType } from 'src/packages/polaris/types';

export default function CheckoutForm({
  interviewType,
  interviewToken,
}: {
  interviewType: MiniInterviewType;
  interviewToken: string;
}) {
  const { chargeAmount } = useDoctorConfirmationContext();

  const onPaymentElementFocus = (e: { elementType: StripeElementType }) => {
    trackPaymentFieldClick({ interviewToken, interviewType, element: e.elementType, chargeAmount });
  };

  return (
    <form id="payment-form">
      <div className="bp-mb-4 bp-flex bp-flex-col bp-items-center bp-gap-2">
        <div className="bp-flex bp-flex-col bp-items-center">
          <div className="bp-font-primary-small bp-text-gray-70">Checkout</div>
          <div className="bp-font-primary-small bp-text-gray-70">Doctor Review & Confirmation</div>
        </div>
        <div className="bp-inline-flex bp-gap-1">
          <div className="bp-font-primary bp-text-[2.25rem] bp-text-gray-100">$</div>
          <div className="bp-font-primary bp-text-[2.25rem] bp-text-gray-100">
            {chargeAmount.toFixed(2)}
          </div>
        </div>
      </div>
      <PaymentElement
        id="payment-element"
        options={{ layout: 'tabs' }}
        onFocus={onPaymentElementFocus}
      />
      <div className="bp-font-primary-smaller bp-mt-6 bp-flex bp-items-center bp-justify-center bp-gap-1 bp-text-gray-60">
        <LockIcon />
        Payment data securely handled via
        <StripeIcon />
      </div>
    </form>
  );
}
